export enum AuthEndpoints {
  "CHECK_SESSION" = "/checkSession",
  "GET_TOKEN" = "/oauth/token",
  "LOGOUT" = "/logout",
}
